export { Remediate } from './remediate';
export { BaselineComponent } from './baseline.component';
export const href =
    'https://docs.microsoft.com/en-us/azure/active-directory/fundamentals/concept-fundamentals-security-defaults';
